<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div>
                    <div class="main-backgroundcolor">
                        <div class="header">
                            Date Format
                        </div>
                    </div>

                    <div class="display">
                        <div class="date-box">
                            <div>July-15-2020</div>
                        </div>

                        <div class="cal">
                            <div><i class="fas fa-calendar-alt color"></i></div>
                        </div>

                    </div>



                </div>

                <div>
                    <div class="main-backgroundcolor">
                        <div class="header">
                            Push Notification Settings
                        </div>
                    </div>

                    <div class="display">
                        <div class="date-box">
                            <div>Follow Ministry</div>
                        </div>

                        <div class="cal">
                            <div>
                                <div class="switch_box box_1">
                                    <input type="checkbox" class="switch_1">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div>
                    <div class="main-backgroundcolor">
                        <div class="header">
                            Account Settings
                        </div>
                    </div>

                    <div class="display">
                        <div class="date-box">
                            <div>Delete Account</div>
                        </div>

                        <div class="cal">
                            <div>
                                <i class="fas fa-trash-alt color"></i>
                            </div>
                        </div>

                    </div>
                    <div class="display">
                        <div class="date-box">
                            <div>Disable Account</div>
                        </div>

                        <div class="cal">
                            <div>
                                <i class="fas fa-ban color"></i>
                            </div>
                        </div>

                    </div>
                </div>



            </div>
            <div class="col-md-3">
                <app-events></app-events>

            </div>
        </div>
    </div>
</div>